import { cn } from "@/lib/utils"

interface SkeletonChatListProps {
  className?: string
  itemCount?: number
}

export function SkeletonChatList({ className, itemCount = 5 }: SkeletonChatListProps) {
  return (
    <div className={cn("w-full", className)}>
      <div className="flex flex-col gap-1">
        {Array.from({ length: itemCount }).map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-[auto_1fr] h-20 md:h-18 rounded-lg bg-card border border-border overflow-hidden animate-pulse"
          >
            {/* Avatar skeleton */}
            <div className="w-20 h-20 md:w-18 md:h-18 bg-muted/60" />

            {/* Chat content skeleton */}
            <div className="flex flex-col py-1.5 pl-2 pr-2 justify-between">
              {/* Desktop layout skeleton */}
              <div className="hidden md:flex items-start justify-between gap-2">
                <div className="h-4 w-32 bg-muted/60 rounded" />
                <div className="h-4 w-12 bg-muted/60 rounded flex-shrink-0" />
              </div>

              <div className="hidden md:flex items-center justify-between gap-2">
                <div className="h-4 w-48 bg-muted/60 rounded" />
                <div className="h-4 w-24 bg-muted/60 rounded flex-shrink-0" />
              </div>

              {/* Mobile layout skeleton */}
              <div className="md:hidden flex flex-col justify-between h-full gap-1">
                <div className="flex items-center justify-between">
                  <div className="h-4 w-32 bg-muted/60 rounded" />
                  <div className="h-4 w-12 bg-muted/60 rounded flex-shrink-0" />
                </div>

                <div className="h-4 w-48 bg-muted/60 rounded" />

                <div className="h-4 w-20 bg-muted/60 rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

